import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface BreadcrumbResponse {
  name: string
}

export function fetchBreadcrumb(
  context: ApiContext,
  resourceType: string,
  resourceId: string
): Promise<BreadcrumbResponse> {
  return apiContextFetch<BreadcrumbResponse>(context, `breadcrumbs/${resourceId}?resource_type=${resourceType}`)
}
